import { Routes } from '@angular/router';
import { UserAuthGuard } from './features/user/guards/user-auth-guard';
import { AccessDeniedComponent } from './features/common/pages/access-denied/access-denied.component';
import { MaintenanceComponent } from './features/common/pages/maintenance/maintenance.component';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard', pathMatch: 'full'
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: 'freely-pay',
    loadChildren: () => import('./features/freely-pay/freely-pay.module').then(m => m.FreelyPayModule)
  }
];
